import zipcode_to_timezone from 'zipcode-to-timezone';
import { formatInTimeZone } from 'date-fns-tz';
import { asDateInTZ } from '@/utilities/convertToISO';

const resolvers = {
    items: {
        last_tracking_event: (item) => {
            if (!item.tracking_events?.length) {
                return null;
            }
            return [...item.tracking_events].sort((a, b) => {
                if (!a.event_time || !b.event_time) return 0;
                return new Date(b.event_time).getTime() - new Date(a.event_time).getTime();
            })[0];
        },
    },
    orders: {
        billing_completion_time_formatted: (order) => {
            const tz = zipcode_to_timezone.lookup(order.dropoff_zip) || 'America/New_York';
            return order.billing_completion_time
                ? formatInTimeZone(asDateInTZ(order.billing_completion_time, tz), tz, 'EEE, MMM d, yyyy')
                : null;
        },
        delivery_date_formatted: (order) => {
            const tz = zipcode_to_timezone.lookup(order.dropoff_zip) || 'America/New_York';
            return order.delivery_date
                ? formatInTimeZone(asDateInTZ(order.delivery_date, tz), tz, 'EEE, MMM d, yyyy')
                : null;
        },
    },
};

export default resolvers;
